import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    flexCenteredGrid: {
      display: 'flex',
      alignItems: 'center',
    },
    divider: {
      width: '100%',
      marginTop: theme.spacing(1.25),
      marginBottom: theme.spacing(1.25),
    },
    centeredGrid: {
      alignSelf: 'center',
    },
    adornmentText: {
      fontWeight: 'bold',
      color: `${theme.palette.grey[700]} !important`,
    },
    inputText: {
      '& .MuiInputBase-input': {
        '&[disabled]': {
          color: theme.palette.grey[700],
        },
      },
    },
    buttons: {
      paddingTop: theme.spacing(),
    },
  }
})
